<template>
  <span>
    <a v-if="linkActive" :href="link" target="_blank">
      <SimplePill :text="text"
                  :active="active"
                  :available="available"
                  :available-icon="availableIcon"
                  :unavailable-icon="unavailableIcon"
                  :disabled-icon="disabledIcon"
                  :outlined="outlined"
                  :available-text="availableText"
                  :unavailable-text="unavailableText"/>
    </a>
    <span v-if="!linkActive">
      <SimplePill :text="text"
                  :active="active"
                  :available="available"
                  :available-icon="availableIcon"
                  :unavailable-icon="unavailableIcon"
                  :disabled-icon="disabledIcon"
                  :outlined="outlined"
                  :available-text="availableText"
                  :unavailable-text="unavailableText"/>
    </span>
  </span>
</template>

<script>
import SimplePill from '@/components/SimplePill';

export default {
  name: "LinkedPill",
  components: {SimplePill},
  comments: {
    SimplePill
  },
  props: {
    text: {
      type: String,
      default: ''
    },
    active: {
      type: Boolean,
      default: true
    },
    available: {
      type: Boolean,
      default: false
    },
    availableIcon: {
      type: String,
      default: null
    },
    unavailableIcon: {
      type: String,
      default: null
    },
    disabledIcon: {
      type: String,
      default: null
    },
    link: {
      type: String,
      default: ''
    },
    linkActive: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    },
    availableText: {
      type: String,
      default: null
    },
    unavailableText: {
      type: String,
      default: null
    },
  }
}
</script>

<style scoped>

</style>
